import { Entity } from "../common-models/Entity";

export class FrontVersion extends Entity {
  number: number;
  numberName: string;
  description: string;
  createdAt: Date;
  mandatory: boolean;
  active: boolean;
}

export const FrontVersionResources = {
  currentNumber: 355,
  currentNumberName: '3.55',
  improvements: [
    'Ajuste código da transportadora J&T Express de JT_EXP para J&T_WS.'
  ]
}